import { styled } from '@mui/material';

export const PageHeaderW = styled('div')`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 1023px) {
    padding-left: 16px;
  }
`;
